import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

import styles from './FileListItem.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

const FileListItem = ({ name, handleRemove, onClick }) => {
	return (
		<HStack
			align='center'
			justify='space-between'
			gap='xsmall'
			className={styles['root']}
			onClick={onClick}
		>
			<h5 className={styles['name']}>{name}</h5>
			{handleRemove && (
				<Icon
					width='17px'
					height='17px'
					name='remove'
					onClick={handleRemove}
					className={styles['icon']}
				/>
			)}
		</HStack>
	)
}

export default FileListItem
